// AppLayout.jsx
import React, {useEffect} from "react";
import SideBar from "./sideBar";
import LayoutHeader from "./Header";
import {Outlet} from "react-router";
import {useDispatch} from "react-redux";
import {USER_ROLE} from "../../store/features/authSlice";

const AppLayout = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    // this function is used to set the global role to determine permissions for users
    // without this role, certain portions of the table access will be restricted
    const setDispatchValue = () => {
      const localStorageUserData = JSON.parse(localStorage.getItem("userData"));
      dispatch(USER_ROLE(localStorageUserData?.role));
    };
    setDispatchValue();
  }, []);

  return (
    <>
      <div className="grid layout-grid w-full h-screen">
        <SideBar />
        <div className=" bg-light-grey" style={{ width: "auto" }}>
          <LayoutHeader />
          <main
            className="p-3 w-full overflow-auto"
            style={{ height: "calc(100vh - 105px)" }}
          >
            {children ? children : <Outlet />}
          </main>
        </div>
      </div>
    </>
  );
};

export default AppLayout;
